// Single source of truth for per-route SEO metadata.
// Used at runtime by src/lib/usePageMeta.js (client-side navigation) and at
// build time by scripts/prerender.mjs, which bakes these values into the
// static HTML served for each route (crawlers like Facebook don't run JS).
//
// Prices are cross-checked against src/data/mock.js by the prerender script;
// the build fails if they drift apart.

export const SITE = {
  origin: 'https://logicgat.es',
  name: 'Logic Gates',
  defaultRobots: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
};

export const PAGES = {
  home: {
    path: '/',
    title: 'Logic Trainer & Logic Gates – Hands-On Digital Logic',
    description:
      'Build real circuits with Logic Trainer: 16 gates, an adjustable clock, memory and a display. $98, shipped worldwide. Explore the Logic Gates board too.',
    ogImage: '/og/logic-trainer.png',
    ogImageAlt: 'Logic Trainer board — hands-on digital logic with gates, clock, memory and display',
  },
  'logic-gates': {
    path: '/product/logic-gates',
    title: 'Logic Gates Board – All 7 Logic Gates on One Hands-On PCB',
    description:
      'Hands-on PCB with AND, OR, NOT, NAND, NOR, XOR and XNOR gates, LED feedback, and printed truth tables. No software or soldering — just 2×AAA batteries. $25.',
    ogImage: '/og/logic-gates.png',
    ogImageAlt: 'Logic Gates board — all 7 logic gates on one hands-on PCB, $25',
    product: {
      name: 'Logic Gates',
      sku: 'logic-gates',
      price: '25.00',
      currency: 'USD',
      images: [1, 2, 3, 4, 5].map((n) => `/images/logic%20gates/${n}.webp`),
      description:
        'A hands-on educational PCB featuring AND, OR, NOT, NAND, NOR, XOR and XNOR gates with real-time LED visualization and silk-screened truth tables. No programming or soldering required — powered by 2×AAA batteries.',
    },
  },
  'logic-learner': {
    path: '/product/logic-learner',
    title: 'Logic Trainer – Build Real Digital Circuits',
    description:
      '16 logic gates, an adjustable clock, memory, counters and a 7-segment display. Wire real digital circuits with jumpers — safe for beginners. $98.',
    ogImage: '/og/logic-trainer.png',
    ogImageAlt: 'Logic Trainer board — wire real digital circuits with clock, memory and 7-segment display, $98',
    product: {
      name: 'Logic Trainer',
      sku: 'logic-learner',
      price: '98.00',
      currency: 'USD',
      images: [1, 2, 3, 4, 5, 6].map((n) => `/images/logic%20trainer/${n}.webp`),
      description:
        'An interactive logic trainer with 16 logic gates, a built-in adjustable clock (0.2–5 Hz or manual step), 4-bit memory, 8-bit shift register, BCD counter, multiplexer and 7-segment display. Wire circuits with jumpers — tolerant to incorrect connections, powered by 3×AAA batteries.',
    },
  },
  about: {
    path: '/about',
    title: 'About Logic Gates – The Story Behind the Boards',
    description:
      'Meet Oliver, the engineer behind Logic Gates. How a hobby project grew with community support, and how each board helps fund development and free learning material.',
  },
  'logic-wiki': {
    path: '/logic-wiki',
    title: 'Logic Wiki – Every Logic Gate Explained with Truth Tables',
    description:
      'Every logic gate explained: AND, OR, NOT, NAND, NOR, XOR and XNOR with truth tables, diagrams and real-world analogies. Free companion curriculum for the boards.',
  },
};

export const NOT_FOUND = {
  path: null, // keep the current URL; page is noindex anyway
  title: 'Page Not Found | Logic Gates',
  description: 'This page does not exist. Browse the Logic Gates boards or the free logic wiki instead.',
  noindex: true,
};

export const PRODUCT_PAGES = {
  'logic-gates': PAGES['logic-gates'],
  'logic-learner': PAGES['logic-learner'],
};
